import { Box, Button, ButtonBaseProps, ListItem, ListItemBaseProps, ListItemButton, ListItemText } from "@mui/material";
import { styled as _styled } from "@mui/material/styles";
import styled from "styled-components";
import { theme, size } from "../../../../helpers/theme";


export const StyledBox = _styled(Box)({
    height: '100%',
    padding: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    "& .MuiBox-root": {
        height: '100%',
    },
});


export const SideBarContainer = styled.div<{ isLoged: boolean; }>`display: ${(props: any) => (props.isLoged ? "flex" : "none")};
@media (max-width: ${size.laptop}) {
display: flex;
color: ${theme.colors.black_primaryText};
}`;

export const SideBarLogo = styled.div`
//margin: 10px 20px 20px 0px;
padding: 10px 20px 20px 10px;
min-width:176px;
cursor: pointer;

`;
export const DivSideBarList1 = styled.div`


`;
export const DivSideBarList2 = styled.div`


`;

export const StyledListItemButton = _styled(ListItemButton)<ButtonBaseProps>(() => ({

    '&.active, &:hover, &.active:hover': {
        '& span': {
            color: `${theme.colors.blue01_active}`,

        }
    },
}));

export const StyledListItem = _styled(ListItem)<ListItemBaseProps>(() => ({

  marginBottom: '20px ',

    '&.active, &:hover, &.active:hover': {
        backgroundColor: `${theme.colors.white}`,
        // border: '1px solid #dfdfdf',
        // width: '196px',
        borderRadius: '8px',

        '& span': {
            color: `${theme.colors.blue01_active}`,

        }
    },
}));
export const StyledButton = _styled(Button)<ButtonBaseProps>(() => ({
    left: '-10px',
    '&.active, &:hover, &.active:hover': {
        backgroundColor: `${theme.colors.gray04_background}`
        // '& span': {
        //     color: `${theme.colors.blue01_active}`,

        // }
    },
}));

export const StyledListItemTex = _styled(ListItemText)({
    whiteSpace: `nowrap`,
    "& .MuiTypography-root": {
        fontWeight: `${theme.fontWeight.normal}`,
        fontSize: "16px",
        lineHeight: "24px",
        fontFamily: `${theme.fonts.interRegular}`,
    },
});